module.exports = __webpack_public_path__ + "img/404.cb516925.png";